import React from "react";
import { Box, Paper } from "@mui/material";

interface MobileLayoutProps {
  title?: string;
  children: React.ReactNode;
  fullBleed?: boolean;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  title,
  children,
  fullBleed = false,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "calc(100vh - 56px)",
        px: fullBleed ? 0 : 1,
        py: fullBleed ? 0 : 1,
        boxSizing: "border-box",
        backgroundColor: "#f6f8fb",
      }}
    >
      {title && (
        <Paper
          elevation={0}
          sx={{
            p: 1.25,
            mb: 1,
            borderRadius: 2,
            fontSize: "1rem",
            fontWeight: 600,
            color: "#0d1b2a",
            backgroundColor: "#ffffff",
            border: "1px solid #e3e8ef",
          }}
        >
          {title}
        </Paper>
      )}
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          fontSize: "0.85rem",
          "& .MuiTable-root, & table": { fontSize: "0.75rem" },
          "& .MuiButton-root": { fontSize: "0.78rem", minHeight: 36 },
          "& .MuiTextField-root .MuiInputBase-input": { fontSize: "0.85rem" },
          "& h1": { fontSize: "1.1rem" },
          "& h2": { fontSize: "1rem" },
          "& h3": { fontSize: "0.95rem" },
          "& h4, & h5, & h6": { fontSize: "0.9rem" },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MobileLayout;
